import React, { useMemo, useState } from 'react';
import { priceToReadable } from 'utils/Helpers';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Pill from 'components/Misc/Pill';
import Nothing from 'components/Misc/Nothing';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import Generator from 'containers/Administrator/Users/Create/Student/Payments/Generator';
import Payment from 'containers/Administrator/Users/Create/Student/Payments/Payment';
import Custom from 'containers/Administrator/Users/Create/Student/Payments/Custom';
import Summary from 'containers/Administrator/Users/Create/Student/Payments/Summary';

const Payments = ({ grade, isDisabled }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	// Calculate total payment amount
	const amount = useMemo(() => {
		return grade.payments.reduce((result, payment) => {
			return {
				...result,
				total: result.total += Number(payment.amount),
				paid: payment.state === 'executed' ? result.paid += Number(payment.amount) : result.paid
			};
		}, {
			paid: 0,
			total: 0
		});
	}, [grade.payments]);

	return (
		<>
			<div className="flex items-center space-x-2">
				<Title
					title="Maksājumu grafiks"
					subtitle="Ģenerēt maksājumu grafiku"
					className="flex-1 text-sm"
				/>

				<Button
					small
					square
					icon="shopping_cart"
					theme="success"
					onClick={handleModal}
					disabled={isDisabled}
				/>
			</div>

			<Modal title="Izveidot maksājumu grafiku" visible={modal} handleModal={handleModal}>
				<div className="space-y-4">
					{/* Payment generator */}
					<Generator grade={grade} />
					
					{/* Custom payment addition */}
					<Custom grade={grade} />

					<Title title="Maksājumu grafiks" />

					{/* Show nothing if no payments added */}
					<Nothing visible={!grade?.payments?.length} />

					{/* Show payment collection */}
					<Show if={grade?.payments?.length}>
						<div className="space-y-4">
							{grade?.payments?.map(payment => (
								<Payment key={payment.key} payment={payment} />
							))}
						</div>
					</Show>

					{/* Payment summary */}
					<Summary payments={grade?.payments} />
				</div>

				{/* Modal's controls */}
				<div className="mt-4 space-x-4 flex justify-end items-center">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={handleModal}
					/>
				</div>
			</Modal>
		</>
	);
};

export default Payments;